import { useEffect } from 'react';

import LoadStatus from 'config/load_status';

import useRecipes from 'domain/recipe/useRecipes';

const useMyRecipesPage = () => {
  const { myRecipes, loadMyRecipes, loadMyRecipesStatus } = useRecipes();

  useEffect(() => {
    loadMyRecipes();
  }, [loadMyRecipes]);

  return {
    recipes: myRecipes,
    isLoading: loadMyRecipesStatus === LoadStatus.LOADING,
    hasFailed: loadMyRecipesStatus === LoadStatus.ERROR,
    hasLoaded: loadMyRecipesStatus === LoadStatus.DONE,
    loadMyRecipes,
  };
};

export default useMyRecipesPage;
